module.exports = __webpack_public_path__ + "static/technical-56c33a192cd8eecf52d86e14a1af8e31.svg";